"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _wdh = require("@demant/wdh");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NECESSARY = 'cookie_cat_necessary';
var FUNCTIONAL = 'cookie_cat_functional';
var STATISTIC = 'cookie_cat_statistic';
var COOKIE_MARKETING = 'cookie_cat_marketing';
var UNCLASSIFIED = 'cookie_cat_unclassified';
var IFRAME_SCRIPT_BLOCK_CSS_SELECTOR = '.iframe-gdpr-template';
var BLOCKED_CONTENT_SRC_ATTRIBUTE = 'data-consent-src';
var BLOCKED_EMBED_CODE_SELECTOR = 'code.embed-code';

var WDHGDPR = /*#__PURE__*/function () {
  function WDHGDPR() {
    _classCallCheck(this, WDHGDPR);

    this.$ = window.jQuery;
    this.DGS = window.DGS;
    this.cookieAPILoaderInterval = null;
    this.consentWatcherInterval = null; // CONFIG

    this.watcherInterval = 1000;
    this.declineCookiesCssSelector = '.decline-cookies';
  }

  _createClass(WDHGDPR, [{
    key: "run",
    value: function run() {
      var _this = this;

      if (!window.CookieConsent) return; // The site is not configured to use cookie handling from cookieinformation.com

      this.$(document).ready(function () {
        _this.cookieAPILoaderInterval = setInterval(function () {
          if (window.CookieConsent.hasOwnProperty('dialog')) {
            clearInterval(_this.cookieAPILoaderInterval);
            _this.CookieConsent = window.CookieConsent;
            _this.CookieInformation = window.CookieInformation;

            _this.setupDeclineCookiesScript(); //Disabled to avoid showing the banner if marketing cookies is not accepted
            //this.showCookieBannerIfCookiesDeclined();


            _this.setupConsentWatcher();

            _this.adjustVideoLinks();
          }
        }, 300);
      });
    }
  }, {
    key: "setupDeclineCookiesScript",
    value: function setupDeclineCookiesScript() {
      var _this2 = this;

      this.$(this.declineCookiesCssSelector).click(function (event) {
        event.preventDefault();

        _this2.CookieConsent.dialog.submitDecline();

        _this2.CookieConsent.renew();
      });
    }
  }, {
    key: "showCookieBannerIfCookiesDeclined",
    value: function showCookieBannerIfCookiesDeclined() {
      var _this3 = this;

      this.DGS.OnLoad.getInstance().register(function () {
        var marketingConsent = _this3.CookieInformation.getConsentGivenFor(COOKIE_MARKETING);

        if (marketingConsent === false) {
          _this3.CookieConsent.renew();
        }
      });
    }
  }, {
    key: "setupConsentWatcher",
    value: function setupConsentWatcher() {
      var _this4 = this;

      this.DGS.OnLoad.getInstance().register(function () {
        var marketingConsent = _this4.CookieInformation.getConsentGivenFor(COOKIE_MARKETING);

        if (!marketingConsent) {
          _this4.consentWatcherInterval = setInterval(function () {
            var marketingConsent = _this4.CookieInformation.getConsentGivenFor(COOKIE_MARKETING);

            if (marketingConsent) {
              clearInterval(_this4.consentWatcherInterval);

              _this4.loadBlockedElements();

              (0, _wdh.triggerEvent)('GDPR-CONSENT-GIVEN');
            }
          }, _this4.watcherInterval);
        } else {
          _this4.loadBlockedElements();
        }
      });
    }
  }, {
    key: "adjustVideoLinks",
    value: function adjustVideoLinks() {
      var _this5 = this;

      this.DGS.OnLoad.getInstance().register(function () {
        var marketingConsent = _this5.CookieInformation.getConsentGivenFor(COOKIE_MARKETING);

        if (!marketingConsent) {
          var that = _this5;
          that.$('.content a').each(function () {
            var $this = that.$(this);

            if ($this.data('embed')) {
              $this.data('embed', $this.data('embed').replace('src', BLOCKED_CONTENT_SRC_ATTRIBUTE));
            }
          });
        }
      });
    }
  }, {
    key: "loadBlockedElements",
    value: function loadBlockedElements() {
      this.reAddRemovedIframes();
      var that = this;
      that.$("[".concat(BLOCKED_CONTENT_SRC_ATTRIBUTE, "]")).each(function () {
        that.$(this).attr('src', $(this).attr(BLOCKED_CONTENT_SRC_ATTRIBUTE));
      });
      that.$(BLOCKED_EMBED_CODE_SELECTOR).each(function () {
        that.$(this).text($(this).text().replace(BLOCKED_CONTENT_SRC_ATTRIBUTE, 'src'));
      });
      that.$('.content a').each(function () {
        var $this = that.$(this);

        if ($this.data('embed')) {
          $this.data('embed', $this.data('embed').replace(BLOCKED_CONTENT_SRC_ATTRIBUTE, 'src'));
        }
      });
    }
  }, {
    key: "reAddRemovedIframes",
    value: function reAddRemovedIframes() {
      var that = this;
      this.$(IFRAME_SCRIPT_BLOCK_CSS_SELECTOR).each(function () {
        var $this = $(this);
        var $parent = $this.parent();
        var htmlText = $this.text();
        htmlText = htmlText.replace(new RegExp('div', 'g'), 'iframe');
        var iframe = that.$(htmlText);
        $parent.append(iframe);
        (0, _wdh.triggerEvent)('GDPR_IFRAME_ADDED', iframe.attr('ID'));
      });
    }
  }], [{
    key: "permissionGiven",
    value: function permissionGiven() {
      if (!window.CookieConsent) return true;
      if (!window.CookieInformation) return false;

      try {
        return window.CookieInformation.getConsentGivenFor(COOKIE_MARKETING);
      } catch (err) {
        return false;
      }
    }
  }, {
    key: "listenForConsent",
    value: function listenForConsent(callback) {
      (0, _wdh.onEvent)('GDPR-CONSENT-GIVEN', callback);
    }
  }]);

  return WDHGDPR;
}();

var _default = WDHGDPR;
exports["default"] = _default;